"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_METHODS = exports.EVENT_STOP_PROPAGATION = exports.EVENT_PERSIST = exports.EVENT_PREVENT_DEFAULT = void 0;
var EVENT_PREVENT_DEFAULT = 'preventDefault';
exports.EVENT_PREVENT_DEFAULT = EVENT_PREVENT_DEFAULT;
var EVENT_PERSIST = 'persist';
exports.EVENT_PERSIST = EVENT_PERSIST;
var EVENT_STOP_PROPAGATION = 'stopPropagation';
exports.EVENT_STOP_PROPAGATION = EVENT_STOP_PROPAGATION;
var EVENT_METHODS = [EVENT_PREVENT_DEFAULT, EVENT_PERSIST, EVENT_STOP_PROPAGATION];
exports.EVENT_METHODS = EVENT_METHODS;